import { Box, Grid, TextField, Typography, Stack } from '@mui/material';
import type { SignupData } from './SignUpWizard';

const darkInputSx = {
  '& .MuiOutlinedInput-root': {
    color: '#f0f0f5',
    '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
    '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.3)' },
    '&.Mui-focused fieldset': { borderColor: '#3d7aff' },
  },
  '& .MuiInputLabel-root': { color: '#6b7280' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#3d7aff' },
  '& .MuiInputBase-input::placeholder': { color: '#6b7280', opacity: 1 },
  '& .MuiFormHelperText-root': { color: '#6b7280' },
};

interface Props {
  data: SignupData;
  onChange: (partial: Partial<SignupData>) => void;
}

export function AdminInfoStep({ data, onChange }: Props) {
  return (
    <Stack spacing={3}>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#f0f0f5' }}>
        Admin Account
      </Typography>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="First Name *"
            value={data.adminFirstName}
            onChange={(e) => onChange({ adminFirstName: e.target.value })}
            fullWidth
            sx={darkInputSx}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            label="Last Name *"
            value={data.adminLastName}
            onChange={(e) => onChange({ adminLastName: e.target.value })}
            fullWidth
            sx={darkInputSx}
          />
        </Grid>
      </Grid>

      <TextField
        label="Email Address *"
        type="email"
        value={data.adminEmail}
        onChange={(e) => onChange({ adminEmail: e.target.value })}
        fullWidth
        placeholder="admin@company.co.za"
        sx={darkInputSx}
      />

      <TextField
        label="Password *"
        type="password"
        value={data.adminPassword}
        onChange={(e) => onChange({ adminPassword: e.target.value })}
        fullWidth
        helperText="Must be at least 8 characters with uppercase, lowercase, number, and special character"
        sx={darkInputSx}
      />

      <Box sx={{ p: 2, borderRadius: 1, backgroundColor: 'rgba(61,122,255,0.05)', border: '1px solid rgba(61,122,255,0.15)' }}>
        <Typography variant="body2" sx={{ color: '#a0a5b5', lineHeight: 1.6 }}>
          This account will be the administrator for your organization. You can invite additional team members after setup.
        </Typography>
      </Box>
    </Stack>
  );
}
